import { render, staticRenderFns } from "./champ-select.vue?vue&type=template&id=70fc23b4&scoped=true&"
import script from "./champ-select.ts?vue&type=script&lang=ts&"
export * from "./champ-select.ts?vue&type=script&lang=ts&"
import style0 from "./champ-select.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./champ-select.vue?vue&type=style&index=1&id=70fc23b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fc23b4",
  null
  
)

export default component.exports